import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useCollectionStore } from "%/dynamic-component-editor/stores/collection-store";

const EMPTY_COLLECTION_ENTITY = Object.freeze({
  collectionId: 0,
  orgId: 0,
  name: "",
  description: "",
  coverImageUrl: "",
  itemCount: 0,
  visibility: "",
  status: "",
  timestampCreated: 0,
  timestampUpdated: 0,
});

// CollectionItemsPage element host. Same pattern as Show/Episode page
// mixins — routes Collection* elements through collection-store so
// production reads the URL-derived collection_id and lazy-fetches the
// collection record.
export const CollectionItemsPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: () => useCollectionStore(),
  created() {
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    const id = this.collectionEntityId;
    if (!id) {
      return;
    }
    useCollectionStore().getOrFetchCollection(id);
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    collectionEntityId() {
      const fromPage = typeof this.pageEntities === "function" ? this.pageEntities()?.collectionItems : this.pageEntities?.collectionItems;
      return fromPage ?? 0;
    },
  },
  methods: {
    getExampleEntity() {
      return {
        collectionId: 1,
        orgId: 1,
        name: "Example Collection",
        description: "A demo collection description.",
        coverImageUrl: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
        itemCount: 5,
        visibility: "public",
        status: "active",
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.collectionEntityId;
      if (!id) {
        return EMPTY_COLLECTION_ENTITY;
      }
      const cached = useCollectionStore().collections?.[id];
      if (cached && (cached.collectionId || cached.collection_id)) {
        return cached;
      }
      return EMPTY_COLLECTION_ENTITY;
    },
  },
};
